export enum WorkOrderStatus {
  Approved = 'Approved',
  InProgress = 'In Progress',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
}
